import {
  handleSuccess,
  handleUpgradeNeeded
} from "@hub/offline-order/src/helpers/saveOfflineSale.helper"
import { handleListOfflineSalesSuccess } from "@hub/offline-order/src/helpers/listOfflineSales.helper"
import { handleUpdateSuccess } from "@hub/offline-order/src/helpers/updateOfflineSale.helper"
import { syncOfflineSale } from "../../services"
import { handleDeleteOfflineSalesSuccess } from "@hub/offline-order/src/helpers/deleteOfflineSales.helper"
import { getSalePayload } from "@hub/offline-order/src/helpers/syncOfflineSale.helper"

const DB_VERSION = 1

const processSaleData = ({ commit, dispatch }, sale, isOffline) => {
  const { address, contract_type, customer, note, offers, payment_info } =
    isOffline ? sale.data : sale

  commit("setSummaryNote", isOffline ? note : sale?.payment_info?.note)
  commit("setSaleToEditId", isOffline ? sale.id : sale.uuid)
  commit("setSaleCode", isOffline ? "" : sale.code)

  const clientData = isOffline ? customer : sale.person
  const addressData = isOffline ? address : sale.address
  const offersData = isOffline ? offers : sale.offers
  const billingAddressData = payment_info.address
  const contractData = { contract_type, payment_info }

  const prefix = isOffline ? "fillOffline" : "fill"

  dispatch(`OfflineOrder/Client/${prefix}Client`, clientData, { root: true })
  dispatch(`OfflineOrder/Address/${prefix}Address`, addressData, { root: true })
  dispatch(`OfflineOrder/Offers/${prefix}Offers`, offersData, { root: true })
  dispatch(`OfflineOrder/Billing/${prefix}BillingAddress`, billingAddressData, {
    root: true
  })
  dispatch(`OfflineOrder/Contract/${prefix}Contract`, contractData, {
    root: true
  })
}

export default {
  saveOfflineSale({ commit }, payload) {
    const request = indexedDB.open("offline_sales", DB_VERSION)

    request.onupgradeneeded = handleUpgradeNeeded
    request.onsuccess = event => handleSuccess(event, commit, payload)
  },

  async listOfflineSales({ commit }, filters) {
    const request = await indexedDB.open("offline_sales", DB_VERSION)

    request.onupgradeneeded = handleUpgradeNeeded
    request.onsuccess = async event =>
      await handleListOfflineSalesSuccess(event, commit, filters)
  },

  updateOfflineSale({ commit }, { payload, id }) {
    const request = indexedDB.open("offline_sales", DB_VERSION)

    request.onupgradeneeded = handleUpgradeNeeded
    request.onsuccess = event => handleUpdateSuccess(event, payload, id, commit)
  },

  fillOfflineSale({ commit, dispatch, state }, sale) {
    if (state.isEditingOfflineSale || state.isEditing) {
      processSaleData({ commit, dispatch }, sale, state.isEditingOfflineSale)
    }
  },

  async removeAllOfflineSales({ commit }) {
    const request = indexedDB.open("offline_sales", DB_VERSION)

    request.onupgradeneeded = handleUpgradeNeeded
    request.onsuccess = event => handleDeleteOfflineSalesSuccess(event, commit)
  },

  async handleSyncOfflineSale({ state, dispatch, commit }) {
    const request = await indexedDB.open("offline_sales", DB_VERSION)

    request.onupgradeneeded = handleUpgradeNeeded
    request.onsuccess = async event => {
      const offlineSales = await handleListOfflineSalesSuccess(event, commit)
      if (offlineSales.length) {
        commit("setIsSyncingOfflineSales", true)
        const payload = offlineSales.map(sale => {
          return getSalePayload(sale)
        })

        try {
          await syncOfflineSale(payload)
          await dispatch("removeAllOfflineSales")
          commit("setAlreadySynced", true)
        } finally {
          commit("setIsSyncingOfflineSales", false)
        }
      }
    }
  }
}
